import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/reservation-edit-people-action-types';

import type {Map} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type ReservationEditPeopleStore = {
    reservation: Map<unknown, unknown>;
};

const initialState = (): ReservationEditPeopleStore => {
    return {
        reservation: Immutable.Map(),
    };
};

const actionsMap: ActionsMap<ReservationEditPeopleStore> = {
    [actionTypes.GET_RESERVATION_SUCCESS]: (state, action) => {
        return {
            reservation: action.data,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<ReservationEditPeopleStore>(initialState(), actionsMap);
